import ReactECharts from "echarts-for-react";
import { useState } from "react";

import { useGetFarmerAnimals } from "@/features/Animals/animalApiSlice.ts";

const PieChart = () => {
  const [count, setCount] = useState(0);
  const { data } = useGetFarmerAnimals();

  const breedCounts = Array.isArray(data)
    ? data
        .map((item: any) => item.racialComposition)
        .filter(
          (breed: any, index: any, self: any) => self.indexOf(breed) === index,
        )
        .map((breed: any) => ({
          value: data.filter((item: any) => item.racialComposition === breed)
            .length,
          name: breed,
        }))
    : [];

  const option = {
    title: {
      text: "Animals Per Breed",
      subtext: "Analytics",
      x: "center",
    },
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    legend: {
      orient: "horizontal",
      left: "right",
      top: "10%",
      data: breedCounts.map((item: any) => item.name),
    },
    series: [
      {
        name: "Animals Per Breed",
        type: "pie",
        radius: "55%",
        center: ["50%", "60%"],
        data: breedCounts,
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  function onChartReady() {
    // console.log("echarts is ready", echarts);
  }

  function onChartClick() {
    // console.log(param, echarts);
    setCount(count + 1);
  }

  function onChartLegendSelectChanged() {
    // console.log(param, echarts);
  }

  return (
    <ReactECharts
      option={option}
      style={{ height: 700 }}
      onChartReady={onChartReady}
      onEvents={{
        click: onChartClick,
        legendselectchanged: onChartLegendSelectChanged,
      }}
    />
  );
};

export default PieChart;
